<template>
	<drawer
			title="Add additional payment"
			z-index="100"
			@updateClose="onClose"
			@updateSave="onSave"
	>
	  <field
		    :class-error="$v.description && $v.description.$error"
			  margin="0 0 10px 0"
			  width="300px"
			  label="Description"
			  placeholder="Enter description"
			  :setInputValue="description"
			  @updateInput="onInput($event, 'description')"
			  is-textarea
	      is-required
	  ></field>
	  <field
			  margin="0 0 0 0"
			  width="300px"
			  label="Amount"
			  placeholder="Select amount"
			  type="number"
			  :setInputValue="amount"
			  @updateInput="onInput($event, 'amount')"
			  icon="dollar"
	  ></field>
	</drawer>
</template>

<script>
import Drawer from "@/shared/Drawer/Drawer";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
	name: "PaymentsDrawer",
	mixins: [ validationMixin ],
	components: { Drawer },
	validations: {
		description: { required },
	},
	data: function() {
		return ({
			amount: 0,
			description: ''
		});
	},
	methods: {
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const { amount, description } = this.$data;
				this.$emit('updateSave', { amount, description });
			} else {
				this.$store.dispatch('setAlert', { type: "error", message: "Saving error" });
			}
		},
		onClose() {
			this.$emit('updateClose');
		},
		onInput({ value }, key) {
			this[key] = value;
		}
	}
};

</script>

<style scoped lang="scss">

</style>
